/* StatusRenderer.js */

"use strict";

class StatusColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("status-column");
        this._rootElem.component = this._model;

        this._icon = document.createElement("base-icon-gl");
        this._rootElem.appendChild(this._icon);

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._icon = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on("StatusStateChanged", (this._updateIcon = this._updateIcon.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("StatusStateChanged");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._updateIcon();
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/
    _updateIcon() {
        this._icon.remove();

        let viewDefs = this._model.getStatusViewDefs();
        let devState = this._model.getStatusState();

        this._icon = document.createElement(viewDefs[devState].elemType);
        this._icon.dataset.icon = viewDefs[devState].iconName;
        this._icon.setAttribute("title", viewDefs[devState].title);
        if (viewDefs[devState].addInvalidAttr) {
            this._icon.dataset.invalid = "true";
        } else {
            this._icon.removeAttribute("data-invalid");
        }
        this.rootElement.dataset.status = viewDefs[devState].iconName;
        this._rootElem.appendChild(this._icon);
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = StatusColumnRenderer;
